<template>
  <div class="collection-component-container">
    <div v-if="finish && dataList.length == 0" class="empty-item" style="padding: 50px 0;">
      <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
    </div>
    <div v-else class="data-list-item">
      <div v-for="(item, index) in dataList" :key="index" class="data-item"  @click="handleToGoodsDetail(item)">
        <div class="img img-cover">
          <img v-if="item.GoodsThumb" :src="item.GoodsThumb" />
          <img v-else src="../../assets/images/no-image-icon.png" />
        </div>
        <div class="goods-info-item">
          <div class="goods-info">
            <div class="name">{{ item.GoodsName }}</div>
            <div class="money">¥ <span>{{ item.GoodsPrice }}</span></div>
          </div>
          <div class="detail-item">
            <div></div>
            <div class="btn">
              <img src="../../assets/pc-images/cart-icon.png" class="icon" />立即购买
            </div>
          </div>
        </div>
      </div>
      <div v-if="!finish && dataList.length > 0" class="more-goods-btn" @click="handleGetDataList">
        <van-loading v-if="loading" size="20" color="#5783fc" />
        <span v-else>查看更多</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentCollectionComponent",
  data() {
    return {
      PageCount: 10,
      Page: 1,
      loading: false,
      finish: false,
      dataList: [],
    }
  },
  mounted() {
    this.handleGetDataList()
  },
  methods: {
    async handleGetDataList() {
      const { PageCount, Page, dataList, finish, loading } = this
      if (finish || loading) {
        return
      }
      const params = {
        PageCount,
        Page
      }
      this.loading = true
      var res = await this.$API.goodsCollectList.post(params)
      this.dataList = [
        ...dataList,
        ...res.info
      ]
      this.Page = Page + 1
      this.finish = res.info.length < PageCount
      this.loading = false
    },
    handleToGoodsDetail(item) {
      if (item.IsClose == 1) {
        return
      }
      this.$router.push({
        path: '/goodsDetail',
        query: {
          id: item.GoodsId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.data-list-item {
  padding: 20px 0;
  .data-item {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    .img {
      width: 75px;
      height: 75px;
      border-radius: 5px;
      overflow: hidden;
    }
    .goods-info-item {
      width: 560px;
      .goods-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #393942;
        font-weight: 500;
        .name {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 15px;
          font-size: 18px;
        }
        .money {
          span {
            font-size: 20px;
          }
        }
      }
      .detail-item {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          width: 90px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 12px;
          background-color: #5783fc;
          border-radius: 2px;
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.more-goods-btn {
  margin: 20px auto 50px;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>